<section>
  <h2 class="fw-bold fs-normal">
    <a class="icon-link text-decoration-none" data-bs-toggle="collapse" href="#crimeGunResultsTable" role="button" aria-expanded="{{relatedResults?.length > 0}}" aria-controls="crimeGunResultsTable">
      <i title="Show or hide results table" aria-hidden="true" [attr.class]="toggleIconClass"></i>
      <span class="text-body">Results</span>
    </a>
  </h2>
  <ng-container *ngIf="showAddIR">
    <button *removeIfUnauthorizedResult="canCreate()" class="btn btn-sm btn-active mb-3" type="button" (click)="addResult.emit()">Add Result</button>
  </ng-container>
  <div #crimeGunResultsPanel id="crimeGunResultsTable" class="collapse {{relatedResults?.length > 0 ? 'show' : ''}}" (hide.bs.collapse)="toggleClass('hide')" (show.bs.collapse)="toggleClass('show')">
    <p-table [value]="relatedResults" [loading]="loading" [showLoader]="true" [columns]="cols" [rows]="rows" [paginator]="!isPrintView" [autoLayout]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" scope="col">
            <span class="text-nowrap">{{col.header}}</span>
            <p-sortIcon *ngIf="col.field !== 'Defendants' " [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <th scope="row" *ngIf="col.field == 'TrackingNumber';else tddefault">
              <button *ngIf="rowData.TrackingNumber" class="btn btn-link" aria-label="{{'Tracking Number '+rowData.TrackingNumber+' details'}}" (click)="showResultDetails.emit(rowData.SuccessStoryID)">{{rowData[col.field]}}</button>
              <button *ngIf="!rowData.TrackingNumber" class="btn btn-link " [attr.aria-label]="'View details'" (click)="showResultDetails.emit(rowData.SuccessStoryID)">View details</button>
            </th>
            <ng-template #tddefault>
              <td [ngSwitch]="col.field">
                <span *ngSwitchCase="'CreatedDate'">{{rowData[col.field] | utcToLocal:'MM/dd/yyyy'}}</span>
                <span *ngSwitchCase="'LastUpdateDate'">{{rowData[col.field] | utcToLocal:'MM/dd/yyyy'}}</span>
                <span *ngSwitchDefault>{{rowData[col.field]}}</span>
              </td>
            </ng-template>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No results found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
